import React from 'react';
import {Image} from '@learningblocks/shared-components/lib/Image';
import {useTranslation} from 'react-i18next';
const TRANSLATION_KEY = {
  Timer: 'Timer.string',
  TimerLinesImage: 'TimerLinesImage.string',
  TimerBaseImage: 'TimerBaseImage.string',
};

import {
  TimerIcon,
  TimerControlIcon
} from '../../../Icons';

export function TimerMain(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  return (
    <Image className={props.className} src={TimerIcon} alt={t(TRANSLATION_KEY.Timer)} />
  );
}

export function TimerBase(props) {
  const {
    t,
    //i18n
  } = useTranslation();

  return (
    <Image
      className={props.className}
      src={TimerControlIcon}
      alt={t(TRANSLATION_KEY.TimerBaseImage)}
    />
  );
}
